import Assets from './assets';
import Chart from './chart';
import Chat from './chat';
import Events from './events';
import Performance from './performance';
import AssetsList from './assetsList';
import BuyList from './buyList';
import KYC from './kyc';

export default {
  EcAssets: Assets,
  EcChart: Chart,
  EcChat: Chat,
  EcEvents: Events,
  EcPerformance: Performance,
  EcAssetsList: AssetsList,
  EcBuyList: BuyList,
  EcKYC: KYC,
}



// WEBPACK FOOTER //
// ./src/components/cards/index.js